import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import {
  REQUEST_KANBAN_BOARD_PERFORM_ACTION,
  TASK_STATUS_ACTIVE,
  TASK_STATUS_INACTIVE,
  TASK_STATUS_PLAN,
} from '../../constants';
import { Cell } from '../Cell';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { VBox, HBox } from '../../../../components/Box';
import { Checkbox } from '../../../../components/Checkbox';
import { selectVehicle } from '../../../Vehicles/selectors';
import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { WithVehicleProperty } from '../../../Vehicles/components/WithVehicleProperty';
import { deleteVehicleProperty, setVehicleProperty } from '../../../Vehicles/actions';
import { VehiclePropertyCheckbox } from '../../../Vehicles/components/VehiclePropertyCheckbox';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';
import env from '../../../../env';
import { Input } from '../../../../components/Input';
import { FormField } from '../../../../components/FormFields';
import { fetchUser } from '../../../Users/actions';
import { REQUEST_USER } from '../../../Users/constants';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { selectUser } from '../../../Users/selectors';
import { getPropByName } from '../../../../utils/props';


const Container = styled.div`

.text-input {
  width: 100%;
  resize: none;
}
`;

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 2],
  DarkOrange: [3, 5],
  Crimson: [6, Infinity],
};

const DEFAULTS = {
  task_label: '1',
  task_test_drive: '1',
  task_interior_inspection: '1',
  task_interior_clean: '1',
  task_interior_pictures: '1',
  task_interio_pictures: '1',
  task_exterior_inspection: '1',
  task_exterior_edit: '1',
  task_exterior_pictures: '1',
};

const FIELDS2 = env.wientjes_installation
  ? {

    task_wash: '0',
    task_polish_showroom: '0',
    task_desticker: '0',
    task_restyle: '0',
    task_spray: '0',
    task_window_repair: '0',
    task_seat_repair: '0',
    task_extra_key: '0',
    task_apk: '0',
    task_workshop: '0',    
    }
    
  : env.autohuis_salland_installation ?
    {
      SALLAND_poetsen_compleet: '0',
      SALLAND_poetsen_buitenkant: '0',
      SALLAND_poetsen_binnenkant: '0',
      SALLAND_velgen_wisselen: '0',
      SALLAND_ozon_behandeling: '0',
      SALLAND_glascoating: '0',
      SALLAND_losse_taak: '0',
      
    }
    : {
      task_interior_polish: '0',
    task_polish_exterior: '0',
    task_restyle: '0',
    task_spray: '0',
    task_attach_replate: '0',
    task_int_ext_polish: '0',
    task_adjust: '0',
    task_desticker: '0',
    task_service: '0',
    task_apk: '0',
    task_recall: '0',
    task_window_repair: '0',
    task_spot_repair: '0',
    task_interior_repair: '0',
    task_repair: '0',
    task_nijboer: '0',
    task_AVN: '0',
    task_hartstad: '0',
    task_ijsseldelta: '0',
    task_attach_parts: '0',
    };

const binaryTypes = {
  task_attach_replate: '0',
};

const STATE = {
  approve: false,
  task_attach_replate: '0',
  ...DEFAULTS,
  ...FIELDS2,
  changed: {},
  buttonClicked: false,
};

/* eslint-disable react/prefer-stateless-function */
class TEST_2Comp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
    
  }

  componentDidMount() {
    this.props.vehicle?.tasksRemarks && this.setState({ tasksRemarks: JSON.parse(this.props.vehicle?.tasksRemarks) });
   // this.props.fetch();
  }

  onSave() {
    const vehicle = this.props.cell.vehicle;
    const remark = {
      id: Date.now(),
      text: this.state.newRemarkText,
      name: getPropByName(this.props?.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
    };
    this.setState({ buttonClicked: true });


    const tasksRemarks = Array.isArray(this.state.tasksRemarks) ? [...this.state.tasksRemarks, remark] : [remark];
    console.log('tasksRemarks:', tasksRemarks);

    this.props.setRemark(vehicle.id, JSON.stringify(tasksRemarks), result => {
      if (result) {
        this.reset();
      }
    });
  }

  reset() {
    this.setState({ ...STATE });
  }

  toggleField = name => {
    if (this.state[name] === '1') {
      this.setState({ [name]: '0' });
    } else {
      this.setState({ [name]: '1' });
    }
  };

  setField = (name, value) => {
    this.setState(prevState => ({
      ...prevState,
      changed: { ...prevState.changed, [name]: value },
    }));
  };

  generatePayload() {
    return this.state?.changed ?? {};
  }

  renderPlannable(name) {
    //use the fetched vehicle in the modal
    return (
      <VehiclePropertyCheckbox
        vehicleId={this.props.cell.vehicle.id}
        propertyName={name}
        key={name}
        changedValue={this.state.changed[name]}
        setField={this.setField.bind(this)}
      />
    );
  
  }

  renderApprove() {
    const vehicle = this.props.cell.vehicle;
    if (!this.state.approve) return null;

    let shownFields = { ...FIELDS2 };

    for (let name in shownFields) {
      if (!!vehicle[name]) {
        shownFields[name] = vehicle[name];
      }
    }

    this.setState({ ...shownFields });

    return (
      <Modal onClose={this.reset.bind(this)} title={this.props.action.label}>
        <VehicleHeader vehicle={vehicle} />
        {vehicle?.fix_damages_details && (
          <div style={{ maxWidth: '400px' }}>
            <strong>{this.lbl(`kanban.transport_card.fix_damages_details`)}: </strong>
            <span>{vehicle?.fix_damages_details}</span>
          </div>
        )}

        <VBox>
        
          <div>&nbsp;</div>
          {_.map(shownFields, (value, name) => this.renderPlannable(name))}
        </VBox>

        {/* <FormField>
          <textarea
            className="text-input"
            value={this.state.newRemarkText}
            onChange={e => this.setState({ newRemarkText: e.target?.value })}
          />
        </FormField>


        <Button
            disabled={this.state.buttonClicked}
            onClick={this.state.editableRemark ? () => this.onEdit(this.state.editableRemark) : this.onSave.bind(this)}
          >
            {this.state.editableRemark ? this.lbl('confirm') : this.lbl('add')}
          </Button> */}

          
        <ModalControls>
          <PerformActionButton
            payload={this.generatePayload()}
            action={this.props.action}
            target={vehicle}
            onChange={this.reset.bind(this)}
          />
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  render() {
    //use the vehicle from the 'action' in the small card
    const vehicle = this.props.cell.vehicle;

    if (this.props.vehicleDetails)
      return (
        <Container>
          <HBox right>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <Button
                  onClick={this.setStateFn({
                    approve: !this.state.approve,
                  })}
                >
                  {this.lbl('interior.inspection.modal.add_tasks')}
                </Button>
              </>
            )}
          </HBox>
          {this.renderApprove()}
        </Container>
      );

    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <Label count={vehicle?.walstreet_check_auto_doorlooptijd_counter} ranges={ranges}>
            {vehicle?.walstreet_check_auto_doorlooptijd_counter || '0'}
          </Label>
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton onClick={this.setStateFn({ approve: !this.state.approve })}>
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

TEST_2Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      `${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`,
      REQUEST_USER,
      `${REQUEST_VEHICLE_PROPERTY_UPDATE}-tasksRemarks`,
      REQUEST_VEHICLE_PROPERTY_UPDATE
    ]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    //loggedUser: selectUser(ownProps?.loggedUserId),
     
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    // fetch() {
    //   dispatch(fetchUser(ownProps?.loggedUserId));
    // },
    setRemark(id, dto) {
      dispatch(setVehicleProperty(id, 'tasksRemarks', dto));

    },
    setProperty(name, value) {
      dispatch(setVehicleProperty(id, name, value));
    },
    deleteProperty(name) {
      dispatch(deleteVehicleProperty(id, name));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const TEST_2 = compose(
  withConnect,
  withRouter,
)(TEST_2Comp);
